// Copyright (C) 2022 TANNER AG

import React from "react";
import { useParams } from "react-router-dom";
import { ContentTypeGroup } from "../../../graphql";
import NavBar from "../../../components/navbar/NavBar";
import ContentIntro from "../../../components/content/ContentIntro";
import Box from "@mui/material/Box";
import Content from "../../../components/content/Content";
import { formatNo, routes } from "../../../lib/utils";
import Stack from "@mui/material/Stack";
import ContentTopicLink from "../../../components/content/ContentTopicLink";
import Divider from "@mui/material/Divider";
import ContentSectionToc from "../../../components/content/section/ContentSectionToc";
import Spinner from "../../../components/Spinner";
import useContentTopic from "../../../hooks/usecontenttopic";
import useContentGroup from "../../../hooks/usecontentgroup";
import { useHashLink } from "../../../hooks/usehashscroll";
import { OFFSET } from "../../../components/content/section/ContentSectionNav";

const EMobilityChapter = () => {
    const { topicKey, subTopicKey } = useParams();
    const { group } = useContentGroup(ContentTypeGroup.Emobility);
    const { topic, fetching } = useContentTopic(ContentTypeGroup.Emobility, [String(topicKey), String(subTopicKey)]);
    const navigate = useHashLink(OFFSET - 80);

    if (fetching) {
        return <Spinner />;
    }

    return (
        <>
            <NavBar
                links={[
                    { label: group?.title, to: routes.eMobility },
                    { label: topic?.parent?.title, to: `${routes.eMobility}/${topic?.parent?.key}` },
                    { label: topic?.title }
                ]}
            />
            <ContentIntro
                title={topic?.title ?? ""}
                theme={topic?.parent?.title}
                content={topic?.description ?? ""}
                no={formatNo([topic?.parent?.no, topic?.no])}
                additional={
                    <Stack spacing={1} sx={{ mt: 3 }}>
                        {topic?.sections
                            ?.filter((section) => section.title)
                            ?.map((section) => (
                                <ContentTopicLink
                                    key={section.id}
                                    id={section.id}
                                    to={`#${section.id}`}
                                    title={section.title}
                                    no={formatNo([topic?.parent?.no, topic?.no, section?.no])}
                                    onClick={() => navigate(section.id)}
                                />
                            ))}
                    </Stack>
                }
            >
                <ContentSectionToc
                    title={group?.title}
                    topics={group?.topics}
                    activeTopicKey={topic?.parent?.key}
                    activeChapterId={topic?.id}
                    path={routes.eMobility}
                    group={ContentTypeGroup.Emobility}
                />
            </ContentIntro>
            <Divider />
            <Box sx={{ pt: 4, bgcolor: "background.paper" }}>
                {topic?.sections?.map((section) => (
                    <Content
                        key={section.id}
                        id={section.id}
                        section={section}
                        no={formatNo([topic?.parent?.no, topic?.no, section?.no])}
                    />
                ))}
            </Box>
        </>
    );
};

export default EMobilityChapter;
